<template>
  <div class="dd-wall-card dd-gift-card">
    <div class="dd-gift-card__icon" aria-hidden="true">
      <img :src="giftIcon" alt="" />
    </div>
    <div class="dd-gift-card__content">
      <h3 class="dd-gift-card__title">{{ title }}</h3>
      <p class="dd-gift-card__subtitle">{{ subtitle }}</p>
      <p class="dd-gift-card__note">{{ note }}</p>
    </div>
    <div class="dd-gift-card__actions">
      <slot name="actions">
        <button class="btn-orange" type="button" @click="$emit('action')">{{ buttonText }}</button>
      </slot>
    </div>
  </div>
</template>

<script>
import giftIcon from '@/assets/img/gift-fill.svg';

export default {
  name: 'GiftSubscriptionCard',
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    note: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      giftIcon,
    };
  },
};
</script>

<style scoped>
.dd-gift-card {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 16px;
  align-items: center;
}
.dd-gift-card__icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: #fff2df;
  color: var(--dd-accent);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.dd-gift-card__icon img {
  width: 28px;
  height: 28px;
}
.dd-gift-card__title {
  margin: 0;
  font-size: 20px;
  line-height: 1.2;
}
.dd-gift-card__subtitle {
  margin: 8px 0 0;
  color: #333;
}
.dd-gift-card__note {
  margin: 8px 0 0;
  color: #666;
  font-size: 13px;
}
.dd-gift-card__actions {
  justify-self: end;
}
@media (max-width: 700px) {
  .dd-gift-card {
    grid-template-columns: 1fr;
  }
  .dd-gift-card__actions {
    justify-self: start;
  }
}
</style>
